var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameBgmEffect = function SvgIconStorygameBgmEffect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.321 2.322A.75.75 0 0 1 13.75 3v18a.75.75 0 0 1-1.225.58l-5.293-4.33H3a1.75 1.75 0 0 1-1.75-1.75v-7c0-.966.784-1.75 1.75-1.75h4.232l5.293-4.33a.75.75 0 0 1 .796-.098Zm-1.071 2.26L7.975 8.08a.75.75 0 0 1-.475.17H3a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25h4.5c.173 0 .34.06.475.17l4.275 3.497V4.583Zm3.755 3.352a.75.75 0 0 1 1.06 0A5.734 5.734 0 0 1 18.75 12a5.734 5.734 0 0 1-1.684 4.066.75.75 0 0 1-1.06-1.06A4.234 4.234 0 0 0 17.25 12a4.234 4.234 0 0 0-1.245-3.005.75.75 0 0 1 0-1.06Zm3.89-2.828a.75.75 0 0 0-1.061 1.06A8.222 8.222 0 0 1 21.25 12c0 2.278-.923 4.34-2.416 5.834a.75.75 0 0 0 1.06 1.06A9.722 9.722 0 0 0 22.75 12a9.722 9.722 0 0 0-2.856-6.894Z",
    fill: "#000",
    fillOpacity: 0.9
  })));
};
export default SvgIconStorygameBgmEffect;